import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  inputLableCustom: {
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    fontSize: '12px !important',
    fontWeight: '550 !important',
    margin: '6px 0px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  timeRangeField: {
    '& .MuiOutlinedInput-root': {
      height: '60px',
      '@media (max-width: 1440px)': {
        height: '45px !important',
      },
      '& fieldset': {
        border: '1px solid grey',
        borderRadius: '8px 0px 0px 8px',
        borderRight: 'none',
      },
      '&:hover fieldset': {
        border: '1px solid grey',
        borderRadius: '8px 0px 0px 8px',
        borderRight: 'none',
      },
      '&.Mui-focused fieldset': {
        border: '1px solid grey',
        borderRadius: '8px 0px 0px 8px',
        borderRight: 'none',
      },
    },
  },
  inputLableCustom1: {
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    fontSize: '12px !important',
    fontWeight: '500 !important',
   
  },
  inputStyles: {
    borderRadius: '8px !important',
    fontSize: '0.9rem !important',
  },

  cardCoverFooter: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    borderRadius: '8px !important',
    color: theme.palette.KenColors.ClientBlack2,
    background: theme.palette.KenColors.ClientBlue,
    position: 'absolute',
    width: '100%',
    bottom: 0,
    lineHeight: '22px',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
  },
  customFieldContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  customUploadField: {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '6px',
    padding: '14px 6px',
    cursor: 'pointer',
    height: '45px',
    alignItems: 'center',
  },
  customUploadFieldText: {
    fontSize: '16px',
    fontWeight: '400 !important',
    color: theme.palette.KenColors.ClientGrey,
    margin: '0px',
    opacity: '0.9',
    paddingLeft: '8px',
  },
  cardCoverPhoto: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative',
    height: '273px',
    borderRadius: '8px !important',
    boxShadow: 'none !important',
    backgroundPosition: 'center !important',
    backgroundSize: 'cover !important',
    marginBottom: '10px',
  },
  scheduleHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '16px 0px',
  },
  scheduleHeader: {
    fontSize: '20px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack2,
  },
  scheduleHeaderSubTitle: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack2,
  },
  multiSelectInputConatiner: {
    height: '135px',
    width: '100%',
    border: `1px solid ${theme.palette.KenColors.grey}`,
    textAlign: 'start',
    overflowY: 'auto',
    overflowX: 'hidden',
    margin: '8px 0px',
    borderRadius: '6px',
  },
  multiSelectInput: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'start',
    gap: '6px',
    width: '100%',
    margin: '10px',
  },
  multiSelectCells: {
    fontSize: '14px',
    fontWeight: '500 !important',
    background: theme.palette.KenColors.ClientGrey3,
    padding: '6px 10px',
    borderRadius: '20px',
    textTransform: 'capitalize',
  },
  multiSelectTextField: {
    border: 'none',
    outline: 'none',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    width: '100%',
    minHeight: '24px',
    resize: 'none',
    lineHeight: '20px',
    background: 'transparent',
    '&::placeholder': {
      fontWeight: '400 !important',
      color: 'rgba(0, 0, 0, 0.42)',
    },
  },
  arrayButton: {
    padding: '6px 10px',
    color: `${theme.palette.KenColors.kenBlack} !important`,
    fontSize: '0.9rem !important',
    borderRadius: '12px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
  },
  arrayButton2: {
    color: `${theme.palette.KenColors.ClientBlue6} !important`,
    fontSize: '16px !important',
    borderRadius: '12px !important',
  },
  arrayButton3: {
    fontSize: '16px !important',
    borderRadius: '8px !important',
  },
}));
